import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglemessagesComponent } from './simple-icons-googlemessages.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglemessagesComponent ],
    exports:      [ SimpleIconsGooglemessagesComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglemessagesModule {}
